<main @fade>
  <form [formGroup]="resetForm" novalidate (ngSubmit)="onSubmit()">
    <nb-card>
      <nb-card-body>
        <div class="alert alert-danger" *ngIf="(state.get('tokenError') | async) === true" i18n="@@LinkNotValid">Ссылка не действительна</div>
        <div class="alert alert-danger" *ngIf="(state.get('resetError') | async) === true" i18n="@@ErrorOccurred">Произошла ошибка</div>
        <div class="alert alert-success" *ngIf="(state.get('resetSuccess') | async) === true" i18n="@@PasswordSuccessfullyChanged">Пароль успешно изменен</div>

        <ng-container *ngIf="(state.get('showForm')  | async) === true">
          <p i18n="@@EnterNewPassword">Укажите новый пароль</p>
          <div class="mb-3">
            <div class="form-control-group">
              <input formControlName="password" [ngClass]="{'input-invalid': !(isValidPassFields | async)}" nbInput id="exampleInputPassword1" type="password" i18n-placeholder placeholder="Введите пароль" required>
            </div>
            <div class="invalid-feedback"
                 *ngIf="resetForm.controls.password.errors?.minlength && resetForm.controls.password.touched" i18n>
              пароль слишком короткий
            </div>
            <div class="invalid-feedback"
                 *ngIf="resetForm.controls.password.errors?.required && resetForm.controls.password.touched" i18n>
              укажите пароль
            </div>
          </div>

          <div class="mb-3">
            <div class="form-control-group">
              <input formControlName="repeatPassword" (focus)="resetForm.controls.repeatPassword.markAsTouched()"
                     [ngClass]="{'input-invalid':!(isValidPassFields | async)}"
                     nbInput id="exampleInputPassword2"
                     type="password" i18n-placeholder placeholder="Повторите пароль" required>
            </div>

            <div class="invalid-feedback" *ngIf="!(isValidPassFields | async) && resetForm.touched" i18n>пароли не совпадают</div>
          </div>
          <button [disabled]="!(isValidForm | async)" type="submit" i18n>Изменить
            пароль
          </button>
        </ng-container>
      </nb-card-body>
    </nb-card>
  </form>
</main>
